var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('doughnut-chart',{attrs:{"data":_vm.data,"labels":_vm.getLabels,"options":{
      cutout: 80,
      plugins: { legend: { display: false }, datalabels: { display: false } },
      responsive: true,
    }}},[(!_vm.hideTotal)?_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$formatNumber(_vm.total))),_c('br'),(_vm.total > 1)?_c('span',[_vm._v("réclam.")]):_c('span',[_vm._v("réclam.")])]}):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }